import { Position } from '@nucleus/types/web';
import React from 'react';
import styled from 'styled-components';
import { BlockLayout, blockLayoutInnerProps } from '../../blockLayouts/Base';
import { BlockPostSearchResults } from '../../blocks/BlockPostSearchResults';
import { getPositionRow, PostSearchResultsBlockLayoutProps } from './PostSearchResultsLayout';

export const PostSearchResultsBlockLayoutContentOnly = (props: PostSearchResultsBlockLayoutProps): JSX.Element => {
  const innerProps = blockLayoutInnerProps(props);

  const row = getPositionRow(props.blockInfoPosition);

  return (
    <StyledBlockLayout {...props} row={row}>
      <StyledContainer>
        <StyledBlockPostSearchResults {...innerProps} block={props.blocks[0]} />
      </StyledContainer>
    </StyledBlockLayout>
  );
};

const StyledBlockPostSearchResults = styled(BlockPostSearchResults)`
  padding: var(--unit-length);
  padding-top: ${(props) => (props.spacing?.top ? 'calc(var(--unit-length) * 0.5)' : undefined)};
  padding-bottom: ${(props) => (props.spacing?.bottom ? 'calc(var(--unit-length) * 0.5)' : undefined)};
`;

const StyledContainer = styled.div``;

const StyledBlockLayout = styled(BlockLayout)<{ row: Position }>`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  ${StyledContainer} {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;

    justify-content: ${(props) => {
      switch (props.row) {
        case Position.Top:
          return 'flex-start';
        case Position.Center:
          return 'center';
        case Position.Bottom:
          return 'flex-end';
        default:
          return;
      }
    }};
  }
`;
